import React from 'react';
import { BlockMath } from 'react-katex';
import 'katex/dist/katex.min.css';

const MathFormulaDisplay = ({ formula, description }) => {
  console.log('MathFormulaDisplay - Received Formula:', formula); // Debugging log

  if (!formula) {
    console.error('Error: formula is undefined or null');
    return <div>Error: No formula to display</div>;
  }

  const formulaString = typeof formula === 'string' ? formula : String(formula);

  return (
    <div className="mt-4">
      <h4 className="text-lg font-semibold mb-2">{description}</h4>
      <BlockMath math={formulaString} />
    </div>
  );
};

export default MathFormulaDisplay;